import React from 'react';

const TabsContext = React.createContext();

export const Tabs = ({ defaultValue, children }) => {
  const [value, setValue] = React.useState(defaultValue);

  return (
    <TabsContext.Provider value={{ value, setValue }}>
      <div className="w-full">{children}</div>
    </TabsContext.Provider>
  );
};

export const TabsList = ({ children }) => {
  return (
    <div className="flex space-x-2 border-b border-gray-200 mb-4">
      {children}
    </div>
  );
};

export const TabsTrigger = ({ value, children }) => {
  const { value: selectedValue, setValue } = React.useContext(TabsContext);
  
  return (
    <button
      className={`px-4 py-2 text-sm font-medium transition-colors
        ${selectedValue === value 
          ? 'text-indigo-600 border-b-2 border-indigo-600' 
          : 'text-gray-600 hover:text-indigo-600'
        }`}
      onClick={() => setValue(value)}
    >
      {children}
    </button>
  );
};

export const TabsContent = ({ value, children }) => {
  const { value: selectedValue } = React.useContext(TabsContext);
  
  if (selectedValue !== value) return null;
  
  return <div>{children}</div>;
};